import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import axios, { isAxiosError } from "axios";

export const getVPNSupportSessionsById = async (
  namespace: string,
  sourceId: string,
) => {
  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/vpnmanager/api/v1/ns/${namespace}/support-sessions/${sourceId}`,
      {
        headers: headers,
      },
    );
    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch support session by ID. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while fetching support session by ID.",
      );
    }
  }
};
